<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-app>
    <!-- GTM noscript -->
    <noscript v-if="gtm_code">
      <iframe :src="getGTMIFrameUrl()" height="0" width="0" style="display:none;visibility:hidden" />
    </noscript>

    <!-- Main Content -->
    <v-main>
      <v-container fluid class="pa-0 mb-0">
        <slot />
      </v-container>
    </v-main>

    <v-dialog v-model="dialog" persistent max-width="575">
      <v-card>
        <v-card-title class="text-h5">You Need access</v-card-title>
        <v-card-text>This page is no longer active</v-card-text>
      </v-card>
    </v-dialog>

    <!-- Footer -->
    <AppFooter />
    <v-footer class="pa-0" color="primary-darken-4">
      <v-col class="text-center text-body-2 sw-white--text font-weight-medium ma-10">
        Copyright &copy; Stonewood Financial {{ new Date().getFullYear() }}. All Rights Reserved.
      </v-col>
    </v-footer>
  </v-app>
</template>

<script setup>
import AppFooter from '@/components/Footer.vue'
import { useBranding } from '@/composables/useBranding'

// eslint-disable-next-line no-unused-vars
const { gtm_code, dialog, getGTMIFrameUrl } = useBranding()
</script>
